module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/feature-2-icon-1.png?ccc25aab";